import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {useInvalidateOnAliveUpdate} from '@github-ui/use-invalidate-on-alive-update'
import type {PullRequestAliveData} from './use-refetch-on-alive-update'

const filter = (data: PullRequestAliveData) =>
  Boolean(data.event_updates?.timeline_updated) || Boolean(data.event_updates?.sidebar_updated)

/**
 * Keeps the Overview activity summary fresh on server-published updates.
 */
export function useActivityLiveUpdates(channel: string | null | undefined): void {
  useInvalidateOnAliveUpdate(channel, {queryKey: [PageData.activity], exact: false}, {filter})
}
